export default "__VITE_ASSET__CWzaJ1wn__"